import { GlobalStyles } from 'fitify-ui-onboarding/src/theme/Global'
import type { Theme } from 'fitify-ui-onboarding/src/types/theme'
import type { PropsWithChildren } from 'react'
import { SkeletonTheme } from 'react-loading-skeleton'
import { ThemeProvider as SCThemeProvider } from 'styled-components'

type Props = PropsWithChildren<{
  backgroundStyle?: string
  theme: Theme
}>

export const ThemeProvider = ({ backgroundStyle, children, theme }: Props) => {
  return (
    <SCThemeProvider theme={theme}>
      <SkeletonTheme
        baseColor={theme.colors['N Surface/Primary']}
        highlightColor={theme.colors['N Surface/Secondary']}
        borderRadius="0.25rem"
        duration={1}
        enableAnimation
      >
        <GlobalStyles $backgroundStyle={backgroundStyle} theme={theme} />
        {children}
      </SkeletonTheme>
    </SCThemeProvider>
  )
}
